export interface ExternalStats {
  id: string;
  type: StatType;
  dateOpen: Date;
  dateClose: Date;
  timeZone: string;
  userId: string;
  resourceId: string;
  userAgent: string;
  source: string;
  checkoutId: string;
}

export enum StatType {
  AUDIO = 'TIME_LISTENING_AUDIO',
  VIDEO = 'TIME_WATCHING_VIDEO',
  TIME_READ_BOOK = 'TIME_READ_BOOK',
  UNKNOWN = 'UNKNOWN',
}
